module.exports = __webpack_public_path__ + "static/media/1-5.5f6328d7.jpg";